// noStock is returned when adding a new entry, lowStock when updating an existing entry's quantity
const BUYABLE_EXCEEDED_CODES = new Set(['quantityBuyableExceeded', 'noStock', 'lowStock'])
export const QUANTITY_BUYABLE_EXCEEDED_KEY = 'cart.add.quantity.buyable.exceeded.cannot.add'

export const isBuyableExceeded = (code: string | undefined): boolean =>
  code !== undefined && BUYABLE_EXCEEDED_CODES.has(code)

type CartErrorResponse = { response?: { json?: () => Promise<unknown> } }
type CartErrorBody = { errors?: Array<{ message?: string }> }

/**
 * Resolves the snackbar translation key for a failed cart mutation:
 * the buyable-exceeded key when the error body reports it (including noStock/lowStock), `fallbackKey` for any
 * other response error, or undefined when the error is not response-shaped.
 */
export const getCartErrorMessageKey = async (error: unknown, fallbackKey: string): Promise<string | undefined> => {
  if (typeof error !== 'object' || error === null || !('response' in error)) {
    return undefined
  }

  const { response } = error as CartErrorResponse
  if (!response?.json) {
    return fallbackKey
  }

  try {
    const body = (await response.json()) as CartErrorBody
    const hasBuyableExceededError = body?.errors?.some((item) => isBuyableExceeded(item?.message)) ?? false

    return hasBuyableExceededError ? QUANTITY_BUYABLE_EXCEEDED_KEY : fallbackKey
  } catch {
    // Error body was not valid JSON — show the generic error message.
    return fallbackKey
  }
}
